var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentDrop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4443 21.8486L14.6943 18.8486L15.8543 17.6886L17.4443 19.2786L21.0343 15.6886L22.1943 17.0986M13.2443 21.8486H5.44434C4.33434 21.8486 3.44434 20.9586 3.44434 19.8486V5.84863C3.44434 4.73863 4.33434 3.84863 5.44434 3.84863H19.4443C20.5543 3.84863 21.4443 4.73863 21.4443 5.84863V13.6486C20.8343 13.2986 20.1643 13.0486 19.4443 12.9286V5.84863H5.44434V19.8486H12.5243C12.6443 20.5686 12.8943 21.2386 13.2443 21.8486ZM12.4443 17.8486H7.44434V15.8486H12.4443M15.1243 13.8486H7.44434V11.8486H17.4443V12.9286C16.5943 13.0686 15.8143 13.3886 15.1243 13.8486ZM17.4443 9.84863H7.44434V7.84863H17.4443",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDrop);
export default __webpack_public_path__ + "static/media/DocumentDrop.1fe57e9e3f5f56df7b79bb4b7db930a3.svg";
export { ForwardRef as ReactComponent };